<script>
export default {
    name: 'I18n',
    functional: true,
    props: {
        tag: {
            type: String,
            default: 'span',
        },
        path: {
            type: String,
            required: true,
            default: '',
        },
    },
    render(h, { slots, props }) {
        const { path, tag } = props;
        const defaultSlots = slots().default || [];
        const vnodes = defaultSlots.filter((child) => child.tag || child.text.trim());

        if (!vnodes.length) {
            return h(tag, path);
        }

        let start = 0;

        const VNodes = vnodes.reduce((acc, vnode, i) => {
            const searchValue = `{${i}}`;
            const foundIndex = path.indexOf(searchValue);

            if (foundIndex === -1) {
                return acc;
            }

            const sentence = path.substring(start, foundIndex);
            start = sentence.length + searchValue.length;

            return [...acc, h('span', sentence), vnode];
        }, []);

        return h(tag, { class: 'i18n' }, VNodes);
    },
};
</script>
